import i18n from 'translations/i18n'
import { isRtl } from 'utils/uiHelpers'

export const formatMonth = isRtl ? 'MMMM' : 'MMM'

export const useAnnualLeaveBalanceConfiguration = (args) => {
  const {
    toil_balance_deduction_enabled,
    total_deducted_and_reserved_balance,
    pending_balance,
    requested_days,
    total_toil_deducted_and_reserved_balance,
    toil_pending_balance,
    toil_available_balance,
    leaveType = i18n.t('label.annual_leave'),
  } = args ?? {}

  const getAnnualLeaveBalanceConfiguration = () => {
    if (!toil_balance_deduction_enabled) {
      return [
        {
          leaveType,
          applied: total_deducted_and_reserved_balance,
          remaining: +pending_balance,
          requestedDays: requested_days,
        },
      ]
    }

    const timeOffInLieu = {
      leaveType: i18n.t('label.field.time_off_in_lieu'),
      applied: +(total_toil_deducted_and_reserved_balance ?? 0).toFixed(2),
      remaining: toil_pending_balance,
      requestedDays: +(total_toil_deducted_and_reserved_balance ?? 0).toFixed(2),
    }

    if (requested_days > (toil_available_balance ?? 0)) {
      return [
        timeOffInLieu,
        {
          leaveType,
          applied: +(total_deducted_and_reserved_balance ?? 0).toFixed(2),
          remaining: pending_balance,
          requestedDays: +(total_deducted_and_reserved_balance ?? 0).toFixed(2),
        },
      ]
    }

    return [timeOffInLieu]
  }
  return {
    getAnnualLeaveBalanceConfiguration,
  }
}
